import { render, staticRenderFns } from "./ClientLogs.vue?vue&type=template&id=1d26b22d&"
import script from "./ClientLogs.vue?vue&type=script&lang=js&"
export * from "./ClientLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports